// extracted by mini-css-extract-plugin
export default {"wrapper":"HWL6EthH84s2Mew7X8mZ","alert":"qzta6FsdhGxid0MZCcUM","alertDescriptionWrapper":"SUnG7gIB3nrpqdOpJa9C","alertDescriptionCTA":"I2hPLMIyXCuRCCt_KAx1"};